/*
  Memories Made Outside homepage behaviour. No dependencies, loaded with defer on the homepage only.

  1. Click tracking: any element with data-mmo-event publishes that event to Shopify's
     customer events bus, where the MMO web pixel forwards it (with consent) through the
     same allowlist as the customiser. Only the location or position is sent.
  2. Route line width: keeps drawn route lines (hero, closing) a steady screen width.
*/
(() => {
  // ---- Analytics -------------------------------------------------------
  document.addEventListener('click', (event) => {
    const el = event.target instanceof Element ? event.target.closest('[data-mmo-event]') : null;
    if (!el) return;
    const payload = {};
    if (el.dataset.mmoLocation) payload.location = el.dataset.mmoLocation;
    if (el.dataset.mmoPosition) payload.position = Number(el.dataset.mmoPosition);
    try {
      window.Shopify?.analytics?.publish?.(el.dataset.mmoEvent, payload);
    } catch {
      // Analytics must never get in the way of the click.
    }
  });

  // ---- Route line width -------------------------------------------------
  // The route SVG scales with its box, so a fixed screen width (--mmo-route-px) is
  // converted to viewBox units for each drawing's size. (non-scaling-stroke would do
  // this, but it breaks the pathLength-based draw animation.)
  const routeLines = document.querySelectorAll('svg.mmo-route-line');
  const setStroke = (svg) => {
    const box = svg.viewBox.baseVal;
    const { width, height } = svg.getBoundingClientRect();
    if (!box || !width || !height) return;
    const unitsPerPx = Math.max(box.width / width, box.height / height);
    const px = parseFloat(getComputedStyle(svg).getPropertyValue('--mmo-route-px')) || 2;
    svg.style.setProperty('--mmo-route-stroke', (px * unitsPerPx).toFixed(3));
  };
  routeLines.forEach(setStroke);
  if ('ResizeObserver' in window) {
    // Watch the container: on an <svg> itself, ResizeObserver reports the drawing's
    // own geometry, which never changes, not its size on the page.
    const ro = new ResizeObserver((entries) =>
      entries.forEach((e) => e.target.querySelectorAll(':scope > svg.mmo-route-line').forEach(setStroke))
    );
    new Set([...routeLines].map((svg) => svg.parentElement)).forEach((el) => el && ro.observe(el));
  }
})();
